import { type ComponentProps, type SyntheticEvent, useCallback } from 'react';

import { TextLink } from '@eneco/sparky';
import { styled } from '@eneco/sparky/stitches';
import { useTracking } from '@eneco/tracking';

const StyledDashboardLink = styled(TextLink, {
  marginTop: 'auto',
  height: 'auto',
  paddingBottom: '0 !important',
});

type StyledDashboardLinkProps = ComponentProps<typeof StyledDashboardLink>;

export type DashboardLinkProps = StyledDashboardLinkProps & {
  trackingComponentName: string;
  trackingComponentType: string;
};

export const DashboardLink = ({
  trackingComponentName,
  trackingComponentType,
  onClick,
  ...rest
}: DashboardLinkProps) => {
  const { trackEventBE } = useTracking();

  const handleClick = useCallback(
    (event: SyntheticEvent) => {
      trackEventBE('dashboard_link_clicked', {
        status: 'click',
        data: {
          component_name: trackingComponentName,
          component_type: trackingComponentType,
        },
      });
      onClick?.(event);
    },
    [onClick, trackEventBE, trackingComponentName, trackingComponentType],
  );

  return <StyledDashboardLink {...rest} onClick={handleClick} />;
};
